import { render, staticRenderFns } from "./TermsConditionsDialog.vue?vue&type=template&id=1ee10038&scoped=true"
import script from "./TermsConditionsDialog.vue?vue&type=script&lang=js"
export * from "./TermsConditionsDialog.vue?vue&type=script&lang=js"
import style0 from "./TermsConditionsDialog.vue?vue&type=style&index=0&id=1ee10038&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee10038",
  null
  
)

export default component.exports